import { useEffect } from 'react'
import { useSignal, batch } from '@preact/signals-react'
import { isEmpty, postSubmit, scrollToComponent } from '@ui-seeker/utils'
import { useAppToast } from '@ui-seeker/app'

import { isSystemBusy } from '@signals'
import { BACKEND_APIS } from '@constants'
import { customerDetailsFilters, reloadCustomerModulesFilters } from '../../@signals'


export default function useCustomerModules() {

    const { showToast } = useAppToast()
    const assignedModules = useSignal([])
    const allModules = useSignal([])
    const isLoading = useSignal(false)

    const fetchModules = () => {
        if (isEmpty(customerDetailsFilters.value)) return

        batch(() => {
            isLoading.value = true
            showToast.promise(
                postSubmit(`${BACKEND_APIS.MANAGEMENT}/customer/customer-modules`, customerDetailsFilters.value)
                    .then(res => {
                        assignedModules.value = res.assignedModules
                        allModules.value = res.allModules
                        isLoading.value = false
                    })
                    .catch(() => {
                        isSystemBusy.value = true
                        isLoading.value = false
                    })
                    .finally(() => scrollToComponent('customer-modules-panel'))
            )
        })
    }

    useEffect(() => {
        if (isEmpty(customerDetailsFilters.value)) {
            assignedModules.value = []
            allModules.value = []
            isLoading.value = false
            return
        }
        fetchModules()
    }, [JSON.stringify(customerDetailsFilters.value)])

    useEffect(() => {
        if (reloadCustomerModulesFilters.value) {
            fetchModules()
            reloadCustomerModulesFilters.value = false
        }
    }, [reloadCustomerModulesFilters.value])

    return {
        assignedModules: assignedModules.value,
        allModules: allModules.value,
        isLoading: isLoading.value
    }
}
